import { TariffType } from '../../../@types/model/transformer/tariffs/tariffs';
import { IRootState } from '../../../@types/redux';
import { connect } from 'react-redux';
import TransformerCaptureList from './List';

const mapStateToProps = (state : IRootState) => {
    return {
        session: state.auth.session,
        tariffType: 'spu' as TariffType,
    };
};

const TransformerCaptureSPUList = connect(
    mapStateToProps,
)(TransformerCaptureList);

export default TransformerCaptureSPUList;
